import { Box, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

function MaterialItem({
    date,
    image,
    description,
    link,
    isMobile
}) {
    function formatDate() {
        const months = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        ];
        const newDate = new Date(date);

        return `${newDate.getDate()} de ${
            months[newDate.getMonth()]
        } de ${newDate.getFullYear()}`;
    }

    return (
        <Link
            to={`/materiais/item?link=${link}`}
            rel="noreferrer"
            style={{
                textDecoration: "none",
            }}
        >
            <Box marginBottom={2} display="flex" flexDirection={isMobile ? "column" : "row"} gap={2}>
                <img
                    src={image}
                    width={"200px"}
                    height={"133px"}
                    alt="imagem de capa da noticia"
                    style={{
                        objectFit: "fill",
                        minWidth: "200px",
                    }}
                />
                <Box>
                    
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="500"
                        fontSize="14px"
                        lineHeight="20px"
                    >
                        {description}
                    </Typography>
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="400"
                        fontSize="12px"
                        lineHeight="14px"
                        marginTop={1}
                    >
                        {formatDate()}
                    </Typography>
                </Box>
            </Box>
        </Link>
    );
}

export default MaterialItem;
